import { render, staticRenderFns } from "./CustomizeComplete.vue?vue&type=template&id=667bb93d&"
import script from "./CustomizeComplete.vue?vue&type=script&lang=js&"
export * from "./CustomizeComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports